export default "__VITE_ASSET__BYWEouDN__"